<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1080 1920"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <g transform="matrix(1,0,0,1,-1286.06,0)">
      <g id="Codescreen" transform="matrix(0.5,0,0,0.5,1286.06,0)">
        <rect x="0" y="0" width="2160" height="3840" style="fill: none" />
        <clipPath id="_clip1">
          <rect x="0" y="0" width="2160" height="3840" />
        </clipPath>
        <g clip-path="url(#_clip1)">
          <g
            id="Layer-1"
            serif:id="Layer 1"
            transform="matrix(1.00072,0,0,1.00072,0.56421,0.000723674)"
          >
            <g
              id="background.jpg"
              transform="matrix(1.99855,0,0,1.99855,-0.563802,-0.000723151)"
            >
              <image
                href="../assets/background.jpg"
                x="0"
                y="0"
                width="1080px"
                height="1920px"
              />
            </g>
            <g
              id="Codefield"
              transform="matrix(-0.999277,0,0,0.999277,2170.86,-90.9724)"
            >
              <path
                d="M1974,954.75C1985.04,954.75 1994,963.704 1994,974.75C1994,1022.99 1994,1145.33 1994,1193.57C1994,1204.61 1985.04,1213.57 1974,1213.57C1789.31,1213.57 383.683,1213.57 198.998,1213.57C187.952,1213.57 178.998,1204.61 178.998,1193.57C178.998,1145.33 178.998,1022.99 178.998,974.75C178.998,963.704 187.952,954.75 198.998,954.75C383.683,954.75 1789.31,954.75 1974,954.75Z"
                style="fill: white"
              />
            </g>
            <g id="Code" transform="matrix(1.99855,0,0,1.99855,1063.25,1069.9)">
              <g transform="matrix(110.638,0,0,110.638,151.573,0)"></g>
              <text
                x="-151.573px"
                y="0px"
                style="
                  font-family: 'Inter', 'Open Sans', sans-serif;
                  font-weight: 500;
                  font-size: 110.638px;
                  fill: rgb(48, 48, 48);
                "
                :style="[
                  getNotFound
                    ? 'fill: rgb(230, 20, 0);'
                    : 'fill: rgb(48, 48, 48);',
                ]"
              >
                {{ code }}
              </text>
            </g>
            <g id="Num1" @click="pressedNumber('1')">
              <g transform="matrix(-0.142487,0,0,0.999277,859.009,301.746)">
                <path
                  d="M1853.74,954.75C1890.94,954.75 1926.61,956.857 1952.92,960.608C1979.22,964.359 1994,969.446 1994,974.75C1994,1022.99 1994,1145.33 1994,1193.57C1994,1198.87 1979.22,1203.96 1952.92,1207.71C1926.61,1211.46 1890.94,1213.57 1853.74,1213.57L319.26,1213.57C282.06,1213.57 246.384,1211.46 220.08,1207.71C193.776,1203.96 178.998,1198.87 178.998,1193.57C178.998,1145.33 178.998,1022.99 178.998,974.75C178.998,969.446 193.776,964.359 220.08,960.608C246.384,956.857 282.06,954.75 319.26,954.75L1853.74,954.75Z"
                  style="fill: white"
                />
              </g>
              <g transform="matrix(1.99855,0,0,1.99855,698.159,1462.51)">
                <g transform="matrix(110.638,0,0,110.638,30.7572,0)"></g>
                <text
                  x="-15.757px"
                  y="0px"
                  style="
                    font-family: 'Inter', 'Open Sans', sans-serif;
                    font-weight: 500;
                    font-size: 110.638px;
                    fill: rgb(48, 48, 48);
                  "
                >
                  1
                </text>
              </g>
            </g>
            <g id="Num4" @click="pressedNumber('4')">
              <g transform="matrix(-0.142487,0,0,0.999277,859.009,657.402)">
                <path
                  d="M1853.74,954.75C1890.94,954.75 1926.61,956.857 1952.92,960.608C1979.22,964.359 1994,969.446 1994,974.75C1994,1022.99 1994,1145.33 1994,1193.57C1994,1198.87 1979.22,1203.96 1952.92,1207.71C1926.61,1211.46 1890.94,1213.57 1853.74,1213.57L319.26,1213.57C282.06,1213.57 246.384,1211.46 220.08,1207.71C193.776,1203.96 178.998,1198.87 178.998,1193.57C178.998,1145.33 178.998,1022.99 178.998,974.75C178.998,969.446 193.776,964.359 220.08,960.608C246.384,956.857 282.06,954.75 319.26,954.75L1853.74,954.75Z"
                  style="fill: white"
                />
              </g>
              <g transform="matrix(1.99855,0,0,1.99855,698.159,1818.28)">
                <g transform="matrix(110.638,0,0,110.638,30.7572,0)"></g>
                <text
                  x="-30.757px"
                  y="0px"
                  style="
                    font-family: 'Inter', 'Open Sans', sans-serif;
                    font-weight: 500;
                    font-size: 110.638px;
                    fill: rgb(48, 48, 48);
                  "
                >
                  4
                </text>
              </g>
            </g>
            <g id="Num7" @click="pressedNumber('7')">
              <g transform="matrix(-0.142487,0,0,0.999277,859.009,1013.06)">
                <path
                  d="M1853.74,954.75C1890.94,954.75 1926.61,956.857 1952.92,960.608C1979.22,964.359 1994,969.446 1994,974.75C1994,1022.99 1994,1145.33 1994,1193.57C1994,1198.87 1979.22,1203.96 1952.92,1207.71C1926.61,1211.46 1890.94,1213.57 1853.74,1213.57L319.26,1213.57C282.06,1213.57 246.384,1211.46 220.08,1207.71C193.776,1203.96 178.998,1198.87 178.998,1193.57C178.998,1145.33 178.998,1022.99 178.998,974.75C178.998,969.446 193.776,964.359 220.08,960.608C246.384,956.857 282.06,954.75 319.26,954.75L1853.74,954.75Z"
                  style="fill: white"
                />
              </g>
              <g transform="matrix(1.99855,0,0,1.99855,698.159,2174.04)">
                <g transform="matrix(110.638,0,0,110.638,30.7572,0)"></g>
                <text
                  x="-30.757px"
                  y="0px"
                  style="
                    font-family: 'Inter', 'Open Sans', sans-serif;
                    font-weight: 500;
                    font-size: 110.638px;
                    fill: rgb(48, 48, 48);
                  "
                >
                  7
                </text>
              </g>
            </g>
            <g id="Num2" @click="pressedNumber('2')">
              <g transform="matrix(-0.142487,0,0,0.999277,1233.46,301.746)">
                <path
                  d="M1853.74,954.75C1890.94,954.75 1926.61,956.857 1952.92,960.608C1979.22,964.359 1994,969.446 1994,974.75L1994,1193.57C1994,1198.87 1979.22,1203.96 1952.92,1207.71C1926.61,1211.46 1890.94,1213.57 1853.74,1213.57L319.26,1213.57C282.06,1213.57 246.384,1211.46 220.08,1207.71C193.776,1203.96 178.998,1198.87 178.998,1193.57C178.998,1145.33 178.998,1022.99 178.998,974.75C178.998,969.446 193.776,964.359 220.08,960.608C246.384,956.857 282.06,954.75 319.26,954.75L1853.74,954.75Z"
                  style="fill: white"
                />
              </g>
              <g transform="matrix(1.99855,0,0,1.99855,1078.65,1462.51)">
                <g transform="matrix(110.638,0,0,110.638,30.7572,0)"></g>
                <text
                  x="-30.757px"
                  y="0px"
                  style="
                    font-family: 'Inter', 'Open Sans', sans-serif;
                    font-weight: 500;
                    font-size: 110.638px;
                    fill: rgb(48, 48, 48);
                  "
                >
                  2
                </text>
              </g>
            </g>
            <g id="Num5" @click="pressedNumber('5')">
              <g transform="matrix(-0.142487,0,0,0.999277,1233.46,657.402)">
                <path
                  d="M1853.74,954.75C1890.94,954.75 1926.61,956.857 1952.92,960.608C1979.22,964.359 1994,969.446 1994,974.75L1994,1193.57C1994,1198.87 1979.22,1203.96 1952.92,1207.71C1926.61,1211.46 1890.94,1213.57 1853.74,1213.57L319.26,1213.57C282.06,1213.57 246.384,1211.46 220.08,1207.71C193.776,1203.96 178.998,1198.87 178.998,1193.57C178.998,1145.33 178.998,1022.99 178.998,974.75C178.998,969.446 193.776,964.359 220.08,960.608C246.384,956.857 282.06,954.75 319.26,954.75L1853.74,954.75Z"
                  style="fill: white"
                />
              </g>
              <g transform="matrix(1.99855,0,0,1.99855,1078.65,1818.28)">
                <g transform="matrix(110.638,0,0,110.638,30.7572,0)"></g>
                <text
                  x="-30.757px"
                  y="0px"
                  style="
                    font-family: 'Inter', 'Open Sans', sans-serif;
                    font-weight: 500;
                    font-size: 110.638px;
                    fill: rgb(48, 48, 48);
                  "
                >
                  5
                </text>
              </g>
            </g>
            <g id="Num8" @click="pressedNumber('8')">
              <g transform="matrix(-0.142487,0,0,0.999277,1233.46,1013.06)">
                <path
                  d="M1853.74,954.75C1890.94,954.75 1926.61,956.857 1952.92,960.608C1979.22,964.359 1994,969.446 1994,974.75L1994,1193.57C1994,1198.87 1979.22,1203.96 1952.92,1207.71C1926.61,1211.46 1890.94,1213.57 1853.74,1213.57L319.26,1213.57C282.06,1213.57 246.384,1211.46 220.08,1207.71C193.776,1203.96 178.998,1198.87 178.998,1193.57C178.998,1145.33 178.998,1022.99 178.998,974.75C178.998,969.446 193.776,964.359 220.08,960.608C246.384,956.857 282.06,954.75 319.26,954.75L1853.74,954.75Z"
                  style="fill: white"
                />
              </g>
              <g transform="matrix(1.99855,0,0,1.99855,1078.65,2174.04)">
                <g transform="matrix(110.638,0,0,110.638,30.7572,0)"></g>
                <text
                  x="-30.757px"
                  y="0px"
                  style="
                    font-family: 'Inter', 'Open Sans', sans-serif;
                    font-weight: 500;
                    font-size: 110.638px;
                    fill: rgb(48, 48, 48);
                  "
                >
                  8
                </text>
              </g>
            </g>
            <g id="Num0" @click="pressedNumber('0')">
              <g transform="matrix(-0.142487,0,0,0.999277,1233.46,1368.73)">
                <path
                  d="M1853.74,954.75C1890.94,954.75 1926.61,956.857 1952.92,960.608C1979.22,964.359 1994,969.446 1994,974.75C1994,1022.99 1994,1145.33 1994,1193.57C1994,1198.87 1979.22,1203.96 1952.92,1207.71C1926.61,1211.46 1890.94,1213.57 1853.74,1213.57L319.26,1213.57C282.06,1213.57 246.384,1211.46 220.08,1207.71C193.776,1203.96 178.998,1198.87 178.998,1193.57C178.998,1145.33 178.998,1022.99 178.998,974.75C178.998,969.446 193.776,964.359 220.08,960.608C246.384,956.857 282.06,954.75 319.26,954.75L1853.74,954.75Z"
                  style="fill: white"
                />
              </g>
              <g transform="matrix(1.99855,0,0,1.99855,1078.65,2529.6)">
                <g transform="matrix(110.638,0,0,110.638,30.7572,0)"></g>
                <text
                  x="-30.757px"
                  y="0px"
                  style="
                    font-family: 'Inter', 'Open Sans', sans-serif;
                    font-weight: 500;
                    font-size: 110.638px;
                    fill: rgb(48, 48, 48);
                  "
                >
                  0
                </text>
              </g>
            </g>
            <g id="Num3" @click="pressedNumber('3')">
              <g transform="matrix(-0.142487,0,0,0.999277,1607.92,301.746)">
                <path
                  d="M1853.74,954.75C1890.94,954.75 1926.61,956.857 1952.92,960.608C1979.22,964.359 1994,969.446 1994,974.75C1994,1022.99 1994,1145.33 1994,1193.57C1994,1198.87 1979.22,1203.96 1952.92,1207.71C1926.61,1211.46 1890.94,1213.57 1853.74,1213.57L319.26,1213.57C282.06,1213.57 246.384,1211.46 220.08,1207.71C193.776,1203.96 178.998,1198.87 178.998,1193.57L178.998,974.75C178.998,969.446 193.776,964.359 220.08,960.608C246.384,956.857 282.06,954.75 319.26,954.75L1853.74,954.75Z"
                  style="fill: white"
                />
              </g>
              <g transform="matrix(1.99855,0,0,1.99855,1453.11,1462.51)">
                <g transform="matrix(110.638,0,0,110.638,30.7572,0)"></g>
                <text
                  x="-30.757px"
                  y="0px"
                  style="
                    font-family: 'Inter', 'Open Sans', sans-serif;
                    font-weight: 500;
                    font-size: 110.638px;
                    fill: rgb(48, 48, 48);
                  "
                >
                  3
                </text>
              </g>
            </g>
            <g id="Num6" @click="pressedNumber('6')">
              <g transform="matrix(-0.142487,0,0,0.999277,1607.92,657.402)">
                <path
                  d="M1853.74,954.75C1890.94,954.75 1926.61,956.857 1952.92,960.608C1979.22,964.359 1994,969.446 1994,974.75C1994,1022.99 1994,1145.33 1994,1193.57C1994,1198.87 1979.22,1203.96 1952.92,1207.71C1926.61,1211.46 1890.94,1213.57 1853.74,1213.57L319.26,1213.57C282.06,1213.57 246.384,1211.46 220.08,1207.71C193.776,1203.96 178.998,1198.87 178.998,1193.57L178.998,974.75C178.998,969.446 193.776,964.359 220.08,960.608C246.384,956.857 282.06,954.75 319.26,954.75L1853.74,954.75Z"
                  style="fill: white"
                />
              </g>
              <g transform="matrix(1.99855,0,0,1.99855,1453.11,1818.28)">
                <g transform="matrix(110.638,0,0,110.638,30.7572,0)"></g>
                <text
                  x="-30.757px"
                  y="0px"
                  style="
                    font-family: 'Inter', 'Open Sans', sans-serif;
                    font-weight: 500;
                    font-size: 110.638px;
                    fill: rgb(48, 48, 48);
                  "
                >
                  6
                </text>
              </g>
            </g>
            <g id="Num9" @click="pressedNumber('9')">
              <g transform="matrix(-0.142487,0,0,0.999277,1607.92,1013.06)">
                <path
                  d="M1853.74,954.75C1890.94,954.75 1926.61,956.857 1952.92,960.608C1979.22,964.359 1994,969.446 1994,974.75C1994,1022.99 1994,1145.33 1994,1193.57C1994,1198.87 1979.22,1203.96 1952.92,1207.71C1926.61,1211.46 1890.94,1213.57 1853.74,1213.57L319.26,1213.57C282.06,1213.57 246.384,1211.46 220.08,1207.71C193.776,1203.96 178.998,1198.87 178.998,1193.57L178.998,974.75C178.998,969.446 193.776,964.359 220.08,960.608C246.384,956.857 282.06,954.75 319.26,954.75L1853.74,954.75Z"
                  style="fill: white"
                />
              </g>
              <g transform="matrix(1.99855,0,0,1.99855,1453.11,2174.04)">
                <g transform="matrix(110.638,0,0,110.638,30.7572,0)"></g>
                <text
                  x="-30.757px"
                  y="0px"
                  style="
                    font-family: 'Inter', 'Open Sans', sans-serif;
                    font-weight: 500;
                    font-size: 110.638px;
                    fill: rgb(48, 48, 48);
                  "
                >
                  9
                </text>
              </g>
            </g>
            <g id="NumX" @click="pressedNumber('x')">
              <g transform="matrix(-0.142487,0,0,0.999277,1607.92,1368.73)">
                <path
                  d="M1853.74,954.75C1890.94,954.75 1926.61,956.857 1952.92,960.608C1979.22,964.359 1994,969.446 1994,974.75C1994,1022.99 1994,1145.33 1994,1193.57C1994,1198.87 1979.22,1203.96 1952.92,1207.71C1926.61,1211.46 1890.94,1213.57 1853.74,1213.57L319.26,1213.57C282.06,1213.57 246.384,1211.46 220.08,1207.71C193.776,1203.96 178.998,1198.87 178.998,1193.57L178.998,974.75C178.998,969.446 193.776,964.359 220.08,960.608C246.384,956.857 282.06,954.75 319.26,954.75L1853.74,954.75Z"
                />
              </g>
              <g transform="matrix(0.761919,0,0,0.761919,641.775,1169.85)">
                <path
                  d="M994.689,1629.34L1011.28,1612.75L1064.58,1666.04L1118.02,1612.75L1135.03,1629.34L1081.6,1682.78L1135.03,1736.08L1118.02,1753.09L1064.58,1699.79L1011.28,1753.09L994.689,1736.08L1047.99,1682.78L994.689,1629.34Z"
                  style="fill: white; fill-rule: nonzero"
                />
              </g>
            </g>
            <g
              transform="matrix(0.761919,0,0,0.761919,1051.34,-289.844)"
              v-if="getNotFound"
            >
              <path
                d="M994.689,1629.34L1011.28,1612.75L1064.58,1666.04L1118.02,1612.75L1135.03,1629.34L1081.6,1682.78L1135.03,1736.08L1118.02,1753.09L1064.58,1699.79L1011.28,1753.09L994.689,1736.08L1047.99,1682.78L994.689,1629.34Z"
                style="fill-opacity: 0.5; fill-rule: nonzero"
              />
            </g>
            <g
              transform="matrix(4.58003,0,0,4.57999,-3096.09,-15026.9)"
              v-if="getLoading"
            >
              <path
                d="M752,3495L742.961,3495L746.339,3491.64C744.703,3490.01 742.444,3489 739.947,3489C735.346,3489 731.55,3492.42 730.984,3496.85C730.984,3496.85 730.811,3498 729.506,3498C728.675,3498 728.001,3497.33 728.001,3496.5C728.001,3496.39 728.014,3496.28 728.038,3496.17C728.924,3490.41 733.916,3486 739.947,3486C743.276,3486 746.289,3487.34 748.47,3489.51L752,3486L752,3495ZM728,3501L737.039,3501L733.661,3504.36C735.296,3505.99 737.556,3507 740.053,3507C744.654,3507 748.45,3503.58 749.016,3499.15C749.016,3499.15 749.189,3498 750.494,3498C751.325,3498 751.999,3498.67 751.999,3499.5C751.999,3499.61 751.986,3499.72 751.962,3499.83C751.076,3505.59 746.084,3510 740.053,3510C736.724,3510 733.711,3508.66 731.53,3506.49L728,3510L728,3501Z"
                style="fill: rgb(123, 200, 0); fill-opacity: 0.5"
              />
            </g>
          </g>
          <g
            transform="matrix(1.00124,0,0,1.00124,-293.249,-0.191595)"
            @click="gotoInactive"
          >
            <g transform="matrix(221,0,0,221,2213.66,526.779)"></g>
            <text
              x="750px"
              y="526.779px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-weight: 500;
                font-size: 221px;
                fill: rgb(254, 254, 254);
              "
            >
              Vul je code in
            </text>
          </g>
          <g
            id="StartBtn"
            transform="matrix(1.00072,0,0,1.00072,-7.43579,237.269)"
            :style="[code.length < 5 ? 'opacity:0.5' : '']"
            @click="checkCode()"
          >
            <g transform="matrix(1,0,0,1,1969.42,2536.78)">
              <path
                d="M0,258.817L-1781.54,258.817C-1790.78,258.817 -1798.27,251.326 -1798.27,242.085L-1798.27,16.733C-1798.27,7.492 -1790.78,0 -1781.54,0L0,0C9.241,0 16.732,7.492 16.732,16.733L16.732,242.085C16.732,251.326 9.241,258.817 0,258.817"
                style="fill: rgb(78, 196, 205); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(1.00052,0,0,1.00052,-275.898,-5.26803)">
              <g transform="matrix(129.135,0,0,129.135,1955.86,2712.17)"></g>
              <text
                x="920px"
                y="2712.17px"
                style="
                  font-family: 'Inter', 'Open Sans', sans-serif;
                  font-weight: 500;
                  font-size: 129.135px;
                  fill: rgb(254, 254, 254);
                "
              >
                Start jouw spel
              </text>
            </g>
          </g>
        </g>
      </g>
    </g>
    <defs></defs>
  </svg>
</template>

<script>
export default {
  name: "EnterCodeScreen",
  computed: {
    getNotFound() {
      return this.$store.getters.getNotFound;
    },
    getLoading() {
      return this.$store.getters.getLoading;
    },
  },
  components: {},
  data: () => ({
    code: "",
  }),
  created() {
    this.timer = setInterval(this.gotoInactive, 15000);
  },
  methods: {
    gotoInactive() {
      this.$store.commit("setGameState", "inactive");
      this.$store.commit("setPlayerState", "ended");
    },
    pressedNumber(digit) {
      clearInterval(this.timer);
      if (digit == "x") {
        this.code = "";
        this.$store.commit("setNotFound", false);
      } else {
        if (this.code.length < 5) {
          this.code = this.code + digit;
        }
      }
    },
    checkCode() {
      let data = {};
      data.code = this.code;
      if (this.code.length > 4) {
        this.$store.dispatch("getPlayer", data);
      }
    },
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped></style>
